var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1597880675({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0002,
    cy: 50,
    r: 41.6667,
    fill: "url(#paint0_linear_558_8457)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5508 35H63.791L61.0254 43.6074L61.002 43.6836L60.959 43.75L60.5996 44.3027L60.5488 44.3789L60.4805 44.4375L53.832 50L60.4805 55.5625L60.5488 55.6211L60.5996 55.6973L60.959 56.25L61.002 56.3164L61.0254 56.3926L63.791 65H66.5508V68.5996H35.4004V65H38.4531L41.2617 56.3906L41.2852 56.3145L41.3281 56.25L41.6875 55.6973L41.7383 55.6211L41.8066 55.5625L48.4551 50L41.8066 44.4375L41.7383 44.3789L41.6875 44.3027L41.3281 43.75L41.2871 43.6855L41.2617 43.6094L38.4473 35H35.4004V31.4004H66.5508V35ZM44.4414 57.9766L42.3262 65H44.1738L51.0293 58.5703L51.4395 58.959L57.8379 65H60.1074L57.8027 57.9805L51.1191 52.3672L44.4414 57.9766ZM44.3574 41.7441H57.8887L60.0215 35H42.3262L44.3574 41.7441Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_558_8457",
    x1: -17.4998,
    y1: -12,
    x2: 92.1505,
    y2: 91.1526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1597880675);
export default __webpack_public_path__ + "static/media/Frame 1597880675.6f1744dbaa0bfeedc31bb5df316577b1.svg";
export { ForwardRef as ReactComponent };